import React from "react";
import {
  FaSearch,
  FaBullhorn,
  FaProjectDiagram,
  FaRocket,
} from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../../assets/Exactness/Header/Bg.svg";

const cardData = [
  {
    title: "High Accuracy Rate",
    description:
      "Get up to 98% verified email addresses, ensuring your messages land where they should.",
    actionText: "Domain Search",
    icon: <FaSearch className="text-[#39C4DC] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#39C4DC]",
    bgcolor: "bg-[#EBFBFC]",
    border: "border-[#99E1ED]",
  },
  {
    title: "Scalable Solutions",
    description:
      "Designed for businesses of all sizes, our API can handle large volumes of requests, enabling you to find emails efficiently without any rate limiting.",
    actionText: "Campaigns",
    icon: <FaBullhorn className="text-[#F88DA0] text-xl" />,
    bgImage: card2Bg,
    color: "text-[#F88DA0]",
    bgcolor: "bg-[#FDEBED]",
    border: "border-[#F9AFBB]",
  },
  {
    title: "Versatile Search Options",
    description:
      "Search by name, domain, role, or LinkedIn ID—whatever suits your strategy best.",
    actionText: "Integrations",
    icon: <FaRocket className="text-[#64D1AE] text-xl" />,
    bgImage: card3Bg,
    color: "text-[#64D1AE]",
    bgcolor: "bg-[#EBFBF4]",
    border: "border-[#98E2C9]",
  },
  {
    title: "Comprehensive Verification",
    description:
      "Every email undergoes rigorous verification like syntax validation, domain verification, and server confirmation to ensure quality results.",
    actionText: "Verifications",
    icon: <FaProjectDiagram className="text-[#cdd164] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#d2d652]",
    bgcolor: "bg-yellow-100",
    border: "border-yellow-400",
  },
];

const Cards = () => {
  return (
    <>
      <div className="grid gap-6 py-6 lg:py-24 bg-gray-50 sm:grid-cols-2 2xl:grid-cols-4 p-6">
        {cardData.map((card, index) => (
          <div
            key={index}
            className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left "
            style={{
              backgroundImage: `url(${card.bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-white opacity-5"></div>
            <div className="relative z-10 flex flex-col h-full">
              <div
                className={`my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 ${card.border} border ${card.bgcolor}`}
              >
                <div className="my-4">{card.icon}</div>
              </div>
              <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600 mb-4">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Cards;
